/* global modForm */
import { defaultQuadLinkValues } from './defaultQuadLinkValues';

/**
 * Get default quad link based on page domain
 * @returns {Object} Quad Link object value
 */

export function getDefaultQuadByDomain() {
	const page = modForm.opts.websiteName.replace(/(qa\.?|staging\.?|www\.?)/g, '');
	const landingPageWithNoQuery = modForm.opts.landingPageNoQuery.replace(/^https?:\/\//, '');

	if (page.includes('bestcompany')) {
		const landingPage = landingPageWithNoQuery;
		let service = landingPage.split('/');
		service = service[2].replace(/-/g, '');
		return defaultQuadLinkValues[page][service];
	} else if (page.indexOf('quotes.improvementcenter.com') > -1 || page.indexOf('callrestorationpro.com') > -1 || page.indexOf('modernize.com') > -1 || page.indexOf('powerhomedeals.com') > -1) {
		if (landingPageWithNoQuery.indexOf('cost-calculator') > -1) {
			let service = landingPageWithNoQuery.split('/');
			service = service[2].replace(/-/g, '');
			service = (typeof defaultQuadLinkValues[page]['cost-calculator'][service] !== 'undefined') ? service : 'default';
			return defaultQuadLinkValues[page]['cost-calculator'][service];
		}
		let service = modForm.opts.landingPageNoQuery.replace(/\/$/g, '').replace(/^(?:[^/]*\/)+/g, '');
		service = (typeof defaultQuadLinkValues[page][service] !== 'undefined') ? service : 'default';
		return defaultQuadLinkValues[page][service];
	}

	return defaultQuadLinkValues[page];
}
